export const mainConfiguration = {
  title: "Sizing Toolset",
}
